import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { faHouse, faGamepad, faPanorama } from '@fortawesome/free-solid-svg-icons'
import './AppIcon.scss'

function AppIcon() {
    return (
        <div className='app-icon-container'>
            <div className='app-icon'>
                <div className='app-icon-title'>
                    <h1>HARUNLUK</h1>
                    <h2>Blog</h2>
                </div>
                <div className='app-icon-mobile'>
                    <h1>H</h1>
                </div>
                <div className='navbar'>
                    <ul>
                        <li>
                            <Link to="/">
                                <div className='navbar-icon'>
                                    
                                <FontAwesomeIcon icon={faHouse} />
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/reviews">
                                <div className='navbar-icon'>
                                <FontAwesomeIcon icon={faGamepad} />
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/wallpapers">
                                <div className='navbar-icon'>
                                <FontAwesomeIcon icon={faPanorama} />
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

    )
}

export default AppIcon